import { faArrowLeft, faCircleExclamation } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Button, IconButton, OutlinedInput, Typography } from '@mui/material';
import { useFormik } from "formik";
import React, { useEffect } from 'react';
import { useAccessibility } from '../../../Store/contexts/AccessibilityContext';
import { ConfirmationDataRecoveryProps } from '../../../interfaces/props/passwordRecovery/ConfirmationDataRecoveryProps';
import { cellphoneMask } from "../../../utils/PhoneRegex";
import { sxButtonLogin, sxButtonText, sxLabel, sxTypographyTitleRecovery, sxValidationMessage } from '../sxProps';
import { EmailCelularValidation } from "../../../interfaces/validation/EmailCelularValidation";
import { ocultarEmail } from "../../../utils/OcultarEmailRegex";
import { ocultarTelefone } from "../../../utils/OcultarTelefone";

const ConfirmationDataRecovery: React.FC<ConfirmationDataRecoveryProps> = ({
  formBack,
  beneficiario,
  allowAlterData,
  openAlertRecoveryQuestions,
  openRecoveryOptions
}) => {

  const { textStyleAccessibility, buttonStyleAccessibility, buttonTextStyleAccessibility } = useAccessibility();

  useEffect(() => {
    formik.setValues({
      email: beneficiario?.email ? beneficiario?.email : "",
      cel: beneficiario?.cel ? beneficiario?.cel : ""
    })
  }, []);

  const formik = useFormik({
    initialValues: {
      email: '',
      cel: ''
    },
    validationSchema: EmailCelularValidation,
    onSubmit: (values) => {
      openRecoveryOptions(values.email, values.cel)
    },
    validateOnChange: false
  });

  return (
    <form style={textStyleAccessibility} className='container-login-painel-rigth' onSubmit={formik.handleSubmit}>
      <div className='password-recovery-container-text'>
        <div className='width-100'>
          <IconButton onClick={() => formBack()} type="button" aria-label="Voltar">
            <FontAwesomeIcon style={textStyleAccessibility} icon={faArrowLeft} />
          </IconButton>
          <Typography component="h2" style={textStyleAccessibility} sx={sxTypographyTitleRecovery} >Olá, {beneficiario?.nome}</Typography>
          <Typography style={textStyleAccessibility} sx={{ textAlign: 'center', marginTop: '5px' }}>Confira os dados e clique em CONTINUAR para redefinir sua senha ou NÃO RECONHEÇO ESSES DADOS para atualizar.</Typography>
        </div>
      </div>
      <div className='width-100'>
        <div className='width-100 margin-bottom-20'>
          <Typography style={textStyleAccessibility} sx={sxLabel}>E-mail</Typography>
          <OutlinedInput
            disabled={!allowAlterData}
            fullWidth
            type={'text'}
            value={formik?.values?.email ? allowAlterData ? formik?.values?.email : ocultarEmail(formik?.values?.email) : ""}
            placeholder='email@email.com'
            onChange={formik.handleChange}
            name='email'
            error={!!formik.errors.email}
            maxRows={1}
            inputProps={{ maxLength: 100 }}
          />
          {formik.errors.email &&
            <div className='container-validation-message'>
              <FontAwesomeIcon icon={faCircleExclamation} size='sm' color='#D84141' />
              <Typography id='errUserName' sx={sxValidationMessage} style={textStyleAccessibility} >{formik.errors.email}</Typography>
            </div>
          }
        </div>
        <div className='width-100 margin-bottom-20'>
          <Typography style={textStyleAccessibility} sx={sxLabel}>Telefone Celular</Typography>
          <OutlinedInput
            disabled={!allowAlterData}
            fullWidth
            type={'text'}
            value={formik?.values?.cel ? allowAlterData ? formik?.values?.cel : ocultarTelefone(formik?.values?.cel) : ""}
            placeholder='(11) 99999-9999'
            onChange={(event) => { formik.setFieldValue('cel', cellphoneMask(event.target.value)) }}
            name='cel'
            error={!!formik.errors.cel}
            maxRows={1}
            inputProps={{ maxLength: 15 }}
          />
          {formik.errors.cel &&
            <div className='container-validation-message'>
              <FontAwesomeIcon icon={faCircleExclamation} size='sm' color='#D84141' />
              <Typography id='errUserName' sx={sxValidationMessage} style={textStyleAccessibility} >{formik.errors.cel}</Typography>
            </div>
          }
        </div>
        <div className='recovery-container-action-data'>
          <Button style={buttonStyleAccessibility} type='submit' variant='contained' sx={sxButtonLogin}>
            <Typography style={buttonTextStyleAccessibility}>Continuar</Typography>
          </Button>
          {!allowAlterData &&
            <Button onClick={openAlertRecoveryQuestions}>
              <Typography style={textStyleAccessibility} sx={sxButtonText}>NÃO RECONHEÇO ESTES DADOS</Typography>
            </Button>
          }
        </div>
      </div>
    </form>
  )
}

export default ConfirmationDataRecovery